import { useEffect, useState } from "react";
import { Plus, Archive } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../lib/api";
import { inr0, curSym } from "../lib/format";

export default function IncomeSources() {
  const [lookups, setLookups] = useState(null);
  const [form, setForm] = useState({ name: "", member_id: "", income_type: "salary", expected_amount: "" });

  const load = () => api.get("/lookups").then((r) => setLookups(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name.trim()) return toast.error("Name required");
    await api.post("/income-sources", {
      name: form.name.trim(),
      member_id: form.member_id || null,
      income_type: form.income_type,
      expected_amount: form.expected_amount ? parseFloat(form.expected_amount) : null,
    });
    setForm({ name: "", member_id: "", income_type: "salary", expected_amount: "" });
    toast.success("Income source added");
    load();
  };

  const archive = async (id) => { await api.delete(`/income-sources/${id}`); toast.success("Archived"); load(); };

  const members = lookups?.members || [];
  const sources = lookups?.income_sources || [];
  const memberName = (id) => members.find((m) => m.id === id)?.display_name || "";
  const input = "w-full h-12 px-4 rounded-xl bg-background border border-border";

  return (
    <div className="px-5 pt-8" data-testid="income-sources-page">
      <h1 className="text-2xl font-heading font-bold tracking-tight">Income Sources</h1>
      <p className="mt-1 text-sm text-muted-foreground">Salaries, businesses and other income you receive regularly.</p>

      <div className="mt-4 bg-white border border-border rounded-2xl p-4 space-y-3">
        <input data-testid="incsrc-name" className={input} placeholder="e.g. TCS Salary" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <select data-testid="incsrc-member" className={input} value={form.member_id} onChange={(e) => setForm({ ...form, member_id: e.target.value })}>
          <option value="">Member (me)</option>
          {members.map((m) => <option key={m.id} value={m.id}>{m.display_name}</option>)}
        </select>
        <div className="grid grid-cols-2 gap-2">
          <select data-testid="incsrc-type" className={input} value={form.income_type} onChange={(e) => setForm({ ...form, income_type: e.target.value })}>
            <option value="salary">Salary</option>
            <option value="business">Business</option>
            <option value="freelance">Freelance</option>
            <option value="insurance">Insurance payment</option>
            <option value="gift">Gift from family</option>
            <option value="other">Other</option>
          </select>
          <input data-testid="incsrc-expected" type="number" inputMode="decimal" className={input} placeholder={`Expected ${curSym()}/mo`} value={form.expected_amount} onChange={(e) => setForm({ ...form, expected_amount: e.target.value })} />
        </div>
        <button data-testid="incsrc-add-btn" onClick={add} className="w-full h-12 rounded-xl bg-primary text-primary-foreground font-medium flex items-center justify-center gap-1"><Plus size={16} /> Add source</button>
      </div>

      <div className="mt-4 bg-white border border-border rounded-2xl overflow-hidden mb-6">
        {sources.length === 0 && <p className="py-8 text-sm text-muted-foreground text-center">No income sources yet.</p>}
        {sources.map((s) => (
          <div key={s.id} className="flex items-center gap-3 px-4 py-3 border-b border-border last:border-0">
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate">{s.name}</p>
              <p className="text-xs text-muted-foreground">{memberName(s.member_id)} · {s.income_type}{s.expected_amount ? ` · ~${inr0(s.expected_amount)}/mo` : ""}</p>
            </div>
            <button data-testid={`incsrc-archive-${s.id}`} onClick={() => archive(s.id)} className="h-10 w-10 flex items-center justify-center rounded-xl text-muted-foreground active:bg-secondary"><Archive size={16} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
